import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-process',
  imports: [SectionWrapperComponent, MatIconModule],
  templateUrl: './process.component.html',
  styleUrl: './process.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.process;
}
